import { useCallback, useEffect } from 'react';
import { TwilioConnectionStatuses } from 'providers/TwilioProvider/constants/TwilioConnectionStatuses';

export const useLogoutEffect = ({
  connectionStatus,
  conversationsClient,
  setConnectionStatus,
  token,
}) => {
  /**
   * Gracefully close the Twilio connection,
   * destroy the ConversationsClient.
   */
  const closeConnection = useCallback(async () => {
    if (!conversationsClient) return;

    conversationsClient?.removeAllListeners();
    await conversationsClient.shutdown();
    conversationsClient = null;
  }, [conversationsClient]);

  /** 1) Shut down the conversationsClient and set it to null in application state */
  useEffect(() => {
    if (!token) closeConnection();
  }, [token]);

  /**
   * 2) Once React SetStateAction has been reliably set for conversationsClient,
   * reset the connection status, so that subsequent logins can trigger client
   * initialization without having to refresh the page.
   */
  useEffect(() => {
    if (conversationsClient === null && !token)
      setConnectionStatus(TwilioConnectionStatuses.UNINITIALIZED);
  }, [connectionStatus, conversationsClient]);
};
